'use client'

import Link from 'next/link'
import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    Sentry.captureException(error, {
      tags: { surface: 'global' },
    })
  }, [error])

  return (
    <html>
      <body className="bg-bg-0 text-text-1">
        <main className="mx-auto flex min-h-[100dvh] max-w-xl flex-col items-start justify-center gap-4 p-6">
          <p className="text-sm text-text-3">Application error</p>
          <h1 className="text-2xl text-text-1">Something went wrong.</h1>
          <p className="text-sm text-text-2">Reload to try again, or return home.</p>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={reset}
              className="h-11 rounded-[var(--radius-lg)] bg-surface-1 px-4 text-sm text-text-1"
            >
              Reload
            </button>
            <Link
              href="/"
              className="inline-flex h-11 items-center rounded-[var(--radius-lg)] bg-surface-1 px-4 text-sm text-text-1"
            >
              Go Home
            </Link>
          </div>
        </main>
      </body>
    </html>
  )
}
